const MANAGED_RESULTS_META = "meta[name='public-results-live-managed']";

export function publicResultsManageCable(documentObject) {
  return Boolean(documentObject?.head?.querySelector(MANAGED_RESULTS_META));
}

export function connectCableImmediately(documentObject) {
  return !publicResultsManageCable(documentObject);
}
